var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "voice-configuration" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp.voiceSettings"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v(_vm._s(_vm.$t("whatsapp.configureVoiceCallSettings"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-container" }, [
      _c("div", { staticClass: "form-layout" }, [
        _c("div", { staticClass: "switches-section" }, [
          _c("h3", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("whatsapp.generalSettings"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _c("label", { staticClass: "switch-label" }, [
                _c("span", { staticClass: "label-text" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.voiceActive"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label-description" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.enableVoiceCallFeature"))),
                ]),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.enable,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload, "enable", $$v)
                  },
                  expression: "payload.enable",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _c("label", { staticClass: "switch-label" }, [
                _c("span", { staticClass: "label-text" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.registration"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label-description" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.enableSipRegistration"))),
                ]),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.metaData.is_register,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload.metaData, "is_register", $$v)
                  },
                  expression: "payload.metaData.is_register",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _c("label", { staticClass: "switch-label" }, [
                _c("span", { staticClass: "label-text" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.forceTcp"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "label-description" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp.forceTcpProtocol"))),
                ]),
              ]),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.metaData.force_tcp,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload.metaData, "force_tcp", $$v)
                  },
                  expression: "payload.metaData.force_tcp",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputs-section" }, [
          _c("div", { staticClass: "inputs-layout" }, [
            _c("div", { staticClass: "input-section" }, [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("whatsapp.sipServerSettings"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "input-label" }, [
                    _c("span", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.host")) + " "),
                      _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label-description" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.sipServerAddress"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "örn: sip.example.com",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.host,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "host", $$v)
                      },
                      expression: "payload.metaData.host",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "input-label" }, [
                    _c("span", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.port"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label-description" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.sipServerPort"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "5060",
                      size: "default",
                      type: "number",
                    },
                    model: {
                      value: _vm.payload.metaData.port,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "port", $$v)
                      },
                      expression: "payload.metaData.port",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-section" }, [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v(_vm._s(_vm.$t("whatsapp.authentication"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "input-label" }, [
                    _c("span", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.user"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label-description" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.sipUserId"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "Kullanıcı ID'si girin",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.user,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "user", $$v)
                      },
                      expression: "payload.metaData.user",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "input-label" }, [
                    _c("span", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.username"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label-description" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.sipUsername"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "Kullanıcı adını girin",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "username", $$v)
                      },
                      expression: "payload.metaData.username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c("label", { staticClass: "input-label" }, [
                    _c("span", { staticClass: "label-text" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.secretKey"))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "label-description" }, [
                      _vm._v(_vm._s(_vm.$t("whatsapp.sipSecretKey"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: { placeholder: "Secret Key girin", size: "default" },
                    model: {
                      value: _vm.payload.metaData.secret_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "secret_key", $$v)
                      },
                      expression: "payload.metaData.secret_key",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "div",
        { staticClass: "footer-actions" },
        [
          _c(
            "a-button",
            {
              staticClass: "cancel-btn",
              attrs: { size: "large" },
              on: { click: _vm.handleCancel },
            },
            [
              _c("a-icon", { attrs: { type: "close" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("whatsapp.cancel")) +
                  "\n            "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "save-btn",
              attrs: { size: "large", type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [
              _c("a-icon", { attrs: { type: "save" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("auto.save")) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }